var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 6.41667V17.4167C19.25 17.9208 19.0706 18.3526 18.7119 18.7119C18.3526 19.0706 17.9208 19.25 17.4167 19.25H4.58333C4.07917 19.25 3.64742 19.0706 3.28808 18.7119C2.92936 18.3526 2.75 17.9208 2.75 17.4167V4.58333C2.75 4.07917 2.92936 3.64742 3.28808 3.28808C3.64742 2.92936 4.07917 2.75 4.58333 2.75H15.5833L19.25 6.41667ZM11 16.5C11.7639 16.5 12.4132 16.2326 12.9479 15.6979C13.4826 15.1632 13.75 14.5139 13.75 13.75C13.75 12.9861 13.4826 12.3368 12.9479 11.8021C12.4132 11.2674 11.7639 11 11 11C10.2361 11 9.58681 11.2674 9.05208 11.8021C8.51736 12.3368 8.25 12.9861 8.25 13.75C8.25 14.5139 8.51736 15.1632 9.05208 15.6979C9.58681 16.2326 10.2361 16.5 11 16.5ZM5.5 9.16667H13.75V5.5H5.5V9.16667Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/SaveIcon.b6433fb6b2a8dd82613c429fb8e98512.svg";
export { ForwardRef as ReactComponent };